import { Typography as e } from "../../Typography/Typography.mjs";
import { Button as t } from "../Button/Button.mjs";
import { Illustration as n } from "../Illustration/Illustration.mjs";
import { ActionSlot as r, BodySlot as i, DesignedContainer as a, LegacyContainer as o, TitleSlot as s } from "./EmptyState.styled.mjs";
import "react";
import { useTranslation as c } from "@maat/store-i18n";
import { jsx as l, jsxs as u } from "react/jsx-runtime";
//#region src/components/EmptyState/EmptyState.tsx
var d = ({ name: d, title: f, body: p, action: m, onAction: h, size: g = "md", align: _ = "center", motion: v = !0, icon: y, message: b, children: x, className: S }) => {
	let { t: C } = c("ds");
	if (!d) return /* @__PURE__ */ u(o, {
		className: S,
		children: [
			y,
			typeof b == "string" ? /* @__PURE__ */ l(e, {
				variant: "body",
				color: "secondary",
				align: "center",
				children: b
			}) : b,
			x
		]
	});
	let w = g === "sm", T = f ?? C(`emptyState.${d}.title`), E = p === void 0 ? C(`emptyState.${d}.body`, "") : p;
	return /* @__PURE__ */ u(a, {
		className: S,
		$align: _,
		$compact: w,
		children: [
			/* @__PURE__ */ l(n, {
				name: d,
				size: g,
				motion: v
			}),
			/* @__PURE__ */ l(s, { children: /* @__PURE__ */ l(e, {
				variant: w ? "h6" : "h5",
				align: _,
				children: T
			}) }),
			E ? /* @__PURE__ */ l(i, { children: /* @__PURE__ */ l(e, {
				variant: "small",
				color: "secondary",
				align: _,
				children: E
			}) }) : null,
			m && h || x ? /* @__PURE__ */ u(r, {
				$align: _,
				children: [m && h ? /* @__PURE__ */ l(t, {
					size: w ? "sm" : "md",
					onClick: h,
					children: m
				}) : null, x]
			}) : null
		]
	});
};
//#endregion
export { d as EmptyState };
